import { CityDetails, OfficeTransformedData } from "src/models/office.model";
import { TransformedData } from "src/models/professional.model";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function createProfessional(
  data: OfficeTransformedData | TransformedData
) {
  return await apiCall.post(API_URL.PROFILE.PROFESSIONAL_PROFILE, data);
}

export async function getProfileInfo(params: string) {
  return await apiCall.get(`${API_URL.PROFILE_COMMON_DATA}?type=${params}`);
}

export const sendResetPassword = async (data: { email: string }) => {
  const res = await apiCall.post(API_URL.PROFILE.SEND_RESET_PASSWORD, data);
  return res;
};

export const approveRejectVersion = async (data: {
  approve: boolean;
  comment?: string;
  uuid: string;
  version: string;
}) => {
  const res = await apiCall.patch(
    API_URL.PROFILE.VERSION_PROFESSIONAL + data.uuid,
    {
      approve: data.approve,
      version: data.version,
      comment: data.comment,
    }
  );
  return res;
};

export const updateProfessional = async (
  uuid: string,
  payload: OfficeTransformedData | TransformedData
) => {
  const url = API_URL.PROFILE.UPDATE_PROFESSIONAL.replace("uuid", uuid).replace(
    /[{}]/g,
    ""
  );
  return await apiCall.patch(url, payload);
};
export const validateEmail = async (payload: {
  email: string;
  private_office?: string;
}) => {
  return await apiCall.patch(API_URL.PROFILE.VALIDATE_EMAIL, payload);
};
export const validateEmailAndMobile = async (payload: {
  email: string;
  phone_number: string;
}) => {
  return await apiCall.patch(
    API_URL.PROFILE.VALIDATE_EMAIL_AND_MOBILE,
    payload
  );
};
export const validatePrimaryAccount = async (payload: {
  email?: string;
  mobile?: string;
  parent_office?: string;
  title?: string;
}) => {
  return await apiCall.patch(API_URL.PROFILE.VALIDATE_PRIMARY_ACCOUNT, payload);
};

export const validateAPAccount = async (payload: {
  email?: string;
  mobile?: string;
  parent_office?: string;
  primary_email?: string;
  title?: string;
}) => {
  return await apiCall.patch(API_URL.PROFILE.VALIDATE_AP_ACCOUNT, payload);
};

export const submitProfile = async (uuid: string) => {
  const url = API_URL.PROFILE.PROFILE_SUBMIT.replace("userUuid", uuid).replace(
    /[{}]/g,
    ""
  );
  const res = await apiCall.patch(url, {
    submit: true,
  });
  return res;
};

export const getCityDetailsWithState = async ({
  state,
  city,
}: {
  city: string;
  state: string;
}): Promise<CityDetails | undefined> => {
  const res = await apiCall.patch(API_URL.PROFILE.GET_STATE_DETAILS, {
    state_code: state,
    city_name: city,
  });
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data as CityDetails;
  }
};

export const checkLicense = async (license: string) => {
  const res = await apiCall.post(API_URL.PROFILE.CHECK_LICENSE, {
    license: license,
  });
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data as { exists: boolean };
  }
};
